export type FetchingStatus = "never" | "ongoing" | "done" | "errored";

export type InvitationSource =
  | "INTERVIEW_CONSOLE"
  | "DEMAND_CONSOLE"
  | "HIRING_PIPELINE"
  | "INVITE_TO_APPLY";

export type HiringPhase =
  | "SUBMIT_TO_REQUISITION"
  | "INTERVIEW_SCHEDULED"
  | "INTERVIEW_NOW";

export type HiringStrategy =
  | "AOP_INTERVIEW"
  | "AOP_INTERVIEW_THIRD_PARTY_BGC"
  | "OPTIMIZED"
  | "OPTIMIZED_THIRD_PARTY_BGC";

export type MatcherInvitationContext = {
  invitationSource: InvitationSource;
  hiringPhase: HiringPhase;
  hiringStrategy: HiringStrategy;
};

export const isHiringStrategyAOPInterview = <O extends string>(
  option: O | HiringStrategy | null,
): option is HiringStrategy =>
  option != null &&
  /^(?:AOP_INTERVIEW|AOP_INTERVIEW_THIRD_PARTY_BGC)$/.test(option);
